import { render } from "./ChoicesNbcl.vue?vue&type=template&id=4a8fa566"
import script from "./ChoicesNbcl.vue?vue&type=script&lang=js"
export * from "./ChoicesNbcl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__